<div class="orgApp-d-flex orgApp-justify-c-center orgApp-login">
  <mat-card [ngClass]="{ 'orgApp-frgt-pwd-card': frgtPwdOtp }">
    <div class="orgApp-d-flex orgApp-otp-div orgApp-flex-dir-col">
      <div class="orgApp-d-flex orgApp-margin-left-20">
        <svg matPrefix width="24" height="24" class="orgApp-margin-top-24 orgApp-text-link" fill="none" (click)="showLogin('back')">
          <use xlink:href="#back-arrow"></use>
        </svg>
        <mat-card-title class="orgApp-otp-heading">
          <b>{{ "login_otp.title" | translate }}</b>
        </mat-card-title>
      </div>

      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16 orgApp-otp-card orgApp-text-center orgApp-align-i-center">
        <mat-card-content class="mat-typography orgApp-otp-dialog-content orgApp-align-i-center orgApp-flex-dir-col orgApp-gap-24">
          <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8" [ngClass]="{ 'orgApp-margin-top-24': frgtPwdOtp }">
            <p class="orgApp-otp-para orgApp-otp-margin">{{ "login_otp.sub_title" | translate }}</p>
            <p class="orgApp-otp-para orgApp-otp-margin"><b>{{ loginService.email }}</b></p>
          </div>

          <ng-otp-input class="orgApp-otp-field" (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>

          <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8 orgApp-text-center">
            <p class="orgApp-otp-margin">
              <ng-container *ngIf="otpExpired; else timerBlock">
                {{ "login_otp.content.code_expired" | translate }}
              </ng-container>
              <ng-template #timerBlock>
                {{ ("login_otp.content.code_expire" | translate) + ' ' + otpMinutes + ':' + (otpSeconds | number : '2.0') }}
              </ng-template>
            </p>

            <p class="orgApp-otp-para orgApp-otp-margin">
              {{ "login_otp.content.code_not_received" | translate }}
              <span
                class="orgApp-text-link orgApp-otp-resend"
                (click)="resendCode()"
                [class.orgApp-dis-otp-resend]="(!showRegenerate && disableResendOtp) || (showRegenerate && disableRegenerate)">
                {{ showRegenerate ? ('login_otp.content.regenerate_code' | translate) : ('login_otp.content.resend_code' | translate) }}
              </span>
            </p>
          </div>
        </mat-card-content>

        <div class="orgApp-otp-btn-container">
          <button mat-stroked-button [disabled] = "!(otpValue?.length === 5)" class="orgApp-raised-btn-primary orgApp-otp-btn" 
           [style.background-color]="otpValue?.length === 5 ? '#217ec5' : '#6db4eb'" (click)="submitOtp()">
            {{ "login_otp.action.continue" | translate }}
          </button>
          <p class="orgApp-text-link orgApp-back-link" (click)="showLogin('login')">
            <b>{{ "login_otp.action.back_to_sign_in" | translate }}</b>
          </p>
        </div>
      </div>
    </div>
  </mat-card>
</div>